// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.active[data-v-9c2c1f26] {\r\n\tcolor: var(--main-blue-3);\r\n\tborder-left: 5px solid var(--main-blue-3);\r\n\tpadding-left: 12px;\n}\n.root[data-v-9c2c1f26] {\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n\theight: 100%;\r\n\tmargin-top: 5px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
